import { render, staticRenderFns } from "./Detail-Milestone.vue?vue&type=template&id=2c25daa5"
import script from "./Detail-Milestone.vue?vue&type=script&lang=js"
export * from "./Detail-Milestone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports